import { clone } from 'lodash'
import isEqual from 'react-fast-compare'

const viewportWidth = document.documentElement.clientWidth
const viewportHeight = document.documentElement.clientHeight

export const isMobile = _ => {
    // don't run each time - calls 'recalculate style'
    return viewportWidth >= 100 && viewportWidth <= 500
}

export const scrollToTop = _ => {
    window.scrollTo(0, 0)
}

export const scaledHeight = _ => {
    let _viewportHeight = viewportHeight

    if(viewportWidth <= 500){
        let scaleFactor = 500/viewportWidth

        _viewportHeight = _viewportHeight*scaleFactor
    }

    return _viewportHeight
}

export const getScreenSize = _ => {
    var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    width = w.innerWidth || e.clientWidth || g.clientWidth,
    height = w.innerHeight|| e.clientHeight|| g.clientHeight;

    return {
        width,
        height
    }
}

export const scaleFactor = _ => {
    return 500/window.screen.width
}

export const assessVisibleRows = (tileRefs, listRefs, cellHeight, overrideThrottle, setState, thisLastRenderedIndex, visibleRows, setCellHeight, isList) => {
    const scrollTop = window.pageYOffset

    // debounce 50% of scroll events
    if(scrollTop % 2 !== 0 && !overrideThrottle){
        return 
    }

    // It should really only be listRef, but seems to fuck up on grid view.
    let newCellHeight = null 

    if(isList){
        let firstExistingListRef = null

        listRefs && listRefs.some(listRef => {
            if(listRef){
                let isValidListRef = false

                listRef.childNodes.forEach(childNode => {
                    if(!childNode.className.includes('spacer')){
                        isValidListRef = true
                    }
                })

                if(isValidListRef){
                    firstExistingListRef = listRef
                    return true
                }
            }
        })

        if(!firstExistingListRef){
            return
        }

        newCellHeight = firstExistingListRef.getBoundingClientRect().height
    }else{    
        let firstExistingTileRef = null

        tileRefs && tileRefs.some(tileRef => {
            if(tileRef){
                firstExistingTileRef = tileRef
                return true
            }
        })
    
        if(!firstExistingTileRef){
            return 
        }

        newCellHeight = firstExistingTileRef.getBoundingClientRect().height
    }

    if(newCellHeight){
        cellHeight = newCellHeight
    }

    const outsideMargin = cellHeight * 1.5

    const tilesOffsetFromTop = (listRefs[0].getBoundingClientRect().top + window.scrollY)
    const windowHeight = window.innerHeight
    const screenBottomBounds = scrollTop + windowHeight + outsideMargin

    // start where the tiles start
    let rowHeightIterator = tilesOffsetFromTop
    let rowIndexIterator = 0
    let rowsVisible = []
    let lastRenderedIndex = clone(thisLastRenderedIndex)

    while(rowHeightIterator < screenBottomBounds){
        if(rowHeightIterator > (scrollTop - outsideMargin) && (rowHeightIterator + cellHeight) < screenBottomBounds){
            rowsVisible.push(rowIndexIterator)
        }

        rowIndexIterator += 1
        // the 40 is cause the margins are doing something fucky with the maths
        rowHeightIterator += (cellHeight + 20)
    }

    lastRenderedIndex++

    if(setCellHeight){
        setCellHeight(cellHeight)
    }

    if(!isEqual(visibleRows, rowsVisible)){
        if(!rowsVisible.length){
            rowsVisible = [0,1]
        }

        setState({
            visibleRows: rowsVisible,
            lastRenderedIndex
        })
    }
}

export const getOffset = el => {
    const rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop

    return { 
        top: rect.top + scrollTop, 
        left: rect.left + scrollLeft,
        bounding: rect
    }
}


// WEBPACK FOOTER //
// ./src/utils/screen.js